import cn from 'classnames';

import styles from '~/style/aigallery/bottomBanner.module.less';
import {bottomBanner as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {NormalBtn} from './components';
import {useQfScreen} from '../comp/utils/hook';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'qianfanBottomBanner';
const BottomBanner = () => {
    const {screenWidth: width} = useQfScreen();
    useCptDuration(id, {
        name: `${applicationName}-bottom-banner-停留时长`
    });
    return (
        <div className={styles.container} id={id}>
            <div
                className={cn(styles.title, `${moduleTitleCn}`)}
                dangerouslySetInnerHTML={{
                    __html: width > 767 ? data.title : data.title_small
                }}
            />
            <div className={cn(styles.context, `${moduleContentCn}`)}>{data.context}</div>
            <NormalBtn
                data={{
                    link: data.link,
                    text: data.btnText,
                    btnType: 'big',
                    className: `${styles['normal-btn']} ${moduleContentCn}`,
                    trackInfo: data.trackInfo
                }}
            />
        </div>
    );
};

export default BottomBanner;
